import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Collapse } from 'antd';
import { createStaticStyles } from 'antd-style';
import { 
	getWidgetData
} from "../../../redux/dashboard/dashboardState";
import { IoDocuments } from "react-icons/io5";
import {  MdDashboard, MdMap } from "react-icons/md";

import { topFarmers, topFarmerColumn } from "./variables/tableDataFarmers";

import Widget from "components/widget/Widget";
import FarmersList from "views/console/default/components/FarmersList";
import RegisteredAnimalsChart from "views/console/default/components/RegisteredAnimalsChart";
import AnimalsStatusChart from "views/console/default/components/AnimalsStatusChart";
import PhilippinesMap from "views/console/default/components/PhilippinesMap";
import RegisteredUsersChart from "./components/RegisteredUsersChart";
import Card from "components/card";
import CardItem from "components/card/CardItem";
import DashboardSearchFilter from "components/search/DashboardSearchFilter";

const Dashboard = ({getWidgetsData, widgetData, requesting, success, error, filters, user, ...props}) => {
  useEffect(() => {
      getWidgetsData(filters);
  }, [getWidgetsData, filters]);

  return (
    <div>

      <div className="mt-3">
        <Collapse
          size="large"
          items={
            [{ key: '1', 
              label: <h4 className="font-bold">Apply Filters</h4>, 
              children: <DashboardSearchFilter withDateRange={false}/> }
            ]
          }
        />
      </div>
      
      {/* Card widgets */}
      <div className="mt-3 grid gap-5 grid-cols-1 lg:grid-cols-4">
        <div className="flex flex-wrap gap-2">
          <Widget
            icon={<MdDashboard className="h-7 w-7" />}
            title={"Registered Farmer"}
            subtitle={widgetData?.farmersCount}
          />
          <Widget
            icon={<IoDocuments className="h-6 w-6" />}
            title={"Registered Animals"}
            subtitle={widgetData?.animalsCount}
          />
          {/* <Widget
            icon={<MdBarChart className="h-7 w-7" />}
            title={"Earned Points"}
            subtitle={widgetData?.totalEarnedPoints}
          />         */}
        </div>
        <div className="col-span-1 lg:col-span-3">
          <Card extra="p-4 card-gradient">
            <div className="mb-4">
              <Widget
                title={"Total Active Animals"}
                subtitle={widgetData?.total_active_animals}
              />
            </div>
            
            <div className="flex flex-wrap gap-2">
              <Widget
                title={"Carabao"}
                subtitle={widgetData?.active_carabao}
                subTitleClass="text-right"
              /> 
              <Widget
                title={"Cattle"}
                subtitle={widgetData?.active_cattle}
                subTitleClass="text-right"
              />
              <Widget
                title={"Goat"}
                subtitle={widgetData?.active_goat}
                subTitleClass="text-right"
              /> 
              <Widget
                title={"Sheep"}
                subtitle={widgetData?.active_sheep}
                subTitleClass="text-right"
              /> 
              <Widget
                title={"Swine"}
                subtitle={widgetData?.active_swine}
                subTitleClass="text-right"
              />  
              <Widget
                title={"Chicken"}
                subtitle={widgetData?.active_chicken}
                subTitleClass="text-right"
              /> 
              <Widget
                title={"Duck"}
                subtitle={widgetData?.active_duck}
                subTitleClass="text-right"
              />    
            </div>
          </Card>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-5 lg:grid-cols-2">
          <RegisteredAnimalsChart/>
          <AnimalsStatusChart/>
      </div>

      <div className="mt-3">
        <RegisteredUsersChart/>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-5 lg:grid-cols-2">
        <FarmersList
          extra="mb-5"
          tableData={topFarmers}
          columnsData={topFarmerColumn}
        />

        <CardItem 
          icon={<MdMap className="h-6 w-6 text-theme-500 dark:text-theme-400"/>}
          title={"Farm Locations"}
          cardMenu={
            <a className="card-menu-button" href='/console/farm-locations-map'>
              View Map Page
            </a>
          }
          extra={"w-full"}
          >
            <div className="pt-4 w-full overflow-x-scroll md:overflow-x-hidden overflow-y-auto">
              <PhilippinesMap />
            </div>
        </CardItem>

      </div>

      
      

      {/* <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">

        <DailyTraffic />

        <PieChartCard />

        <MiniCalendar />

      </div>
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        <FarmersList
          extra="mb-5"
          tableData={topFarmers}
          columnsData={topFarmerColumn}
        />

        <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />
      </div> */}
      
    </div>
  );
};

const mapStateToProps = (state) => ({
    requesting: state.dashboard.widgetsData?.requesting,
    success: state.dashboard.widgetsData?.success,
    error: state.dashboard.widgetsData?.error,
    widgetData: state.dashboard.widgetsData.data,
    filters: state.dashboardFiters?.filters,
    user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  getWidgetsData: () => dispatch(getWidgetData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
